import LayoutContainer from 'components/Common/LayoutContainer/LayoutContainer'
import Heading from 'components/Luxkit/Typography/Heading'
import Group from 'components/utils/Group'
import React, { useCallback } from 'react'
import styled from 'styled-components'
import { uspContent } from './constants'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Pane from 'components/Common/Pane'
import { rem } from 'polished'
import TextButton from 'components/Luxkit/Button/TextButton'
import { accountAccessShowLogin } from 'actions/UiActions'
import { useAppDispatch } from 'hooks/reduxHooks'
import * as Analytics from 'analytics/analytics'
import { uspAboutUsEvent } from 'analytics/snowplow/events'
import { isLoggedIn } from 'selectors/accountSelectors'
import { connect } from 'react-redux'
import ValuePropositionItems from 'home/components/ValuePropositionBanner/ValuePropositionItems'

const Container = styled.div`
  background-color: ${({ theme }) => theme.palette.neutral.eight};
`
const StyledLayoutContainer = styled(LayoutContainer)`
  padding-left: ${rem(16)};
  padding-right: 0;

  ${mediaQueryUp.md}{
    padding-right: ${rem(16)};
  }
`

const ContainerRight = styled.div`
  padding-right: ${rem(16)};
  ${mediaQueryUp.md}{
    padding-right: 0;
  }
`

const StyledPane = styled(Pane)`
  overflow: hidden;
  padding-top: ${rem(40)};
  padding-bottom: ${rem(40)};
`

const USPGroup = styled(Group)`
  padding-top: ${rem(24)};
`

const CTAGroup = styled(Group)`
  padding-top: ${rem(24)};
`

interface MappedProps {
  loggedIn: boolean | undefined;
  regionCode: string;
}

interface Props {
  className?: string
}

function FrontPageUSPComponent(props: MappedProps & Props) {
  const { className, loggedIn, regionCode } = props
  const values = uspContent(regionCode)
  const dispatch = useAppDispatch()

  const onLearnMoreClick = useCallback(() => {
    Analytics.track('usp-about-us-event', uspAboutUsEvent('learn_about_us'))
  }, [])

  const onSignupClick = useCallback(() => {
    dispatch(accountAccessShowLogin())
  }, [dispatch])

  return <Container>
    <StyledLayoutContainer className={className} >
      <StyledPane>
        <ContainerRight>
          <Heading variant="heading2">
            {loggedIn && <>
              Discover a <i>better way</i> to travel
            </>}
            {!loggedIn && <>
              Join today and discover a <i>better way</i> to travel
            </>}
          </Heading>
        </ContainerRight>
        <USPGroup direction="vertical" gap={16}>
          <ValuePropositionItems values={values} />
        </USPGroup>
        <ContainerRight>
          <CSSBreakpoint min="sm">
            <CTAGroup gap={8} direction="horizontal" smHorizontalAlign="end">
              <TextButton kind="tertiary" onClick={onLearnMoreClick} to="/about-us" target="_blank">
                Learn more about us
              </TextButton>
              {!loggedIn && <TextButton kind="primary" onClick={onSignupClick}>
                Sign up and save
              </TextButton>
              }
            </CTAGroup>
          </CSSBreakpoint>
          <CSSBreakpoint max="xs">
            <CTAGroup gap={8} direction="vertical">
              {!loggedIn && <TextButton kind="primary" onClick={onSignupClick}>
                Sign up and save
              </TextButton>
              }
              <TextButton kind="tertiary" onClick={onLearnMoreClick} to="/about-us" target="_blank">
                Learn more about us
              </TextButton>
            </CTAGroup>
          </CSSBreakpoint>
        </ContainerRight>
      </StyledPane>
    </StyledLayoutContainer>
  </Container>
}

function mapStateToProps(state: App.State) {
  return {
    loggedIn: isLoggedIn(state),
    regionCode: state.geo.currentRegionCode,
  }
}

export default connect(mapStateToProps)(FrontPageUSPComponent)
